import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { useMedplum } from "@medplum/react";

import { ActionIcon, Card, Container, Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { IconChevronRight } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";
import { fetchChecklists } from "@/services/checklist";
import { useAppDispatch } from "@/store";
import { getAllAssociatedChecklistTasks, loadChecklists } from "@/store/slices/checklists";
import { ChecklistTask } from "@/types/checklist-task";

import ChecklistTodosDrawer from "./components/ChecklistTodosDrawer";

function ChecklistTodos() {
  const medplum = useMedplum();
  const dispatch = useAppDispatch();
  const { clientId } = useParams() as { clientId: string };
  const [opened, { open, close }] = useDisclosure(false);
  const getTasksByOwner = useSelector(getAllAssociatedChecklistTasks);
  const allAssociatedChecklistTasks = getTasksByOwner(clientId);

  useEffect(() => {
    (async () => {
      const fetchedChecklists = await fetchChecklists(medplum, clientId);
      dispatch(loadChecklists(fetchedChecklists as ChecklistTask[]));
    })();
  }, [clientId, dispatch, medplum]);

  return (
    <Card bg="white" mb={{ base: "-xs", xs: 0 }}>
      <ChecklistTodosDrawer opened={opened} onClose={close} tasks={allAssociatedChecklistTasks} />
      <TextWrapper fz="md" mb="xs" variant="bold">
        Client To-Dos
      </TextWrapper>
      <Container w="100%" c="burgundy.9" bg="burgundy.0">
        <Group py="sm" w="100%" justify="space-between">
          {allAssociatedChecklistTasks.length > 0 ? (
            <>
              <TextWrapper variant="bold">
                {allAssociatedChecklistTasks.length}{" "}
                {allAssociatedChecklistTasks.length === 1 ? "Task" : "Tasks"}
              </TextWrapper>
              <ActionIcon
                bg="inherit"
                onClick={open}
                data-testid="checklist-todos-open-drawer-icon"
              >
                <IconChevronRight color="var(--mantine-color-burgundy-9)" />
              </ActionIcon>
            </>
          ) : (
            <TextWrapper w="100%" ta="center" variant="bold">
              No tasks assigned
            </TextWrapper>
          )}
        </Group>
      </Container>
    </Card>
  );
}

export default ChecklistTodos;
